import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

function ShoppingList({ refreshKey }) {
  const [items, setItems] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchItems();
  }, [refreshKey]);

  async function fetchItems() {
    try {
      const res = await apiFetch('/api/shopping');
      if (res.ok) setItems(await res.json());
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  async function addItem(e) {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const res = await apiFetch('/api/shopping', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: text.trim() }),
      });
      if (res.ok) setItems(await res.json());
      setText('');
    } catch (err) {
      console.error(err);
    }
  }

  async function toggleItem(id) {
    try {
      const res = await apiFetch(`/api/shopping/${id}/toggle`, { method: 'PUT' });
      if (res.ok) setItems(await res.json());
    } catch (err) {
      console.error(err);
    }
  }

  async function deleteItem(id) {
    setItems((prev) => prev.filter((i) => i.id !== id));
    try {
      await apiFetch(`/api/shopping/${id}`, { method: 'DELETE' });
    } catch (err) {
      console.error(err);
    }
  }

  const unchecked = items.filter((i) => !i.checked);
  const checked = items.filter((i) => i.checked);

  return (
    <section className="card shopping-section">
      <h2>Shopping List</h2>
      <form onSubmit={addItem} className="shopping-add">
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Add item..."
          className="shopping-input"
        />
        <button type="submit" className="shopping-add-btn">+</button>
      </form>
      {loading ? (
        <p className="loading">Loading...</p>
      ) : (
        <ul className="shopping-list">
          {unchecked.map((item) => (
            <li key={item.id} className="shopping-item">
              <button className="goal-check" onClick={() => toggleItem(item.id)}>
                {'\u2B1C'}
              </button>
              <span className="shopping-text">{item.text}</span>
              <button className="shopping-del" onClick={() => deleteItem(item.id)}>&times;</button>
            </li>
          ))}
          {checked.map((item) => (
            <li key={item.id} className="shopping-item checked">
              <button className="goal-check" onClick={() => toggleItem(item.id)}>
                {'\u2705'}
              </button>
              <span className="shopping-text">{item.text}</span>
              <button className="shopping-del" onClick={() => deleteItem(item.id)}>&times;</button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default ShoppingList;
